/** 树组件，添加右键菜单 的配置项 */
export default
{
  data()
  {
    return {
      selNode: null,            //当前点击节点对象
      func: [],
      funcgrp: []
    }
  },
  mounted()
  {
    //tree的右键菜单对象
    this._contextmenu = this.$refs.contextmenu
    this._contextmenu.addComm()
  },
  methods:
  {
    /**
     * 根据当前选中的节点对象，获取右键菜单列表。
     * @method
     * @param   {Node}            node    节点对象(node.data是节点源数据对象)
     * @returns {Array<Object>}   右键菜单列表数组
     */
    getMenu(node)
    {
      return []
    },
    /**
     * 树节点点击相应事件。
     * @method
     * @param   {Object}  data    传递给 data 属性的数组中该节点所对应的对象
     * @param   {Node}    node    节点对应的 Node
     */
    handleNodeClick(data, node)
    {
      this._contextmenu.hide()
      this.selNode = node
      this.onClickNode(...arguments)
    },
    /**
     * 节点右键时的响应函数
     * @method
     * @param   {Event}   event   事件对象
     * @param   {Object}  data    传递给 data 属性的数组中该节点所对应的对象
     * @param   {Node}    node    节点对应的 Node
     * @param   {Node}    refNode 节点组件本身
     */
    nodeContext(event, data, node, refNode)
    {
      event.preventDefault()
      this._contextmenu.clear()
      this.selNode = node
      let menu = this.getMenu(node)
      this._contextmenu.addCustom(menu)
      this._contextmenu.show({top: event.clientY, left: event.clientX}, {})
    },
    /**
     * 树节点点击相应事件。
     * @method
     * @param   {Object}  data    传递给 data 属性的数组中该节点所对应的对象
     * @param   {Node}    node    节点对应的 Node
     */
    onClickNode(data, node)
    {
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/app/com/fileManage/js/ContextmenuCfg.js